import { AxiosResponse } from 'axios';
import v1 from '../v1';

export async function findList(center: ILngLat, radius: number, state: number, coordinateSystem: string = 'wgs84'): Promise<AxiosResponse<any>> {
  return await v1({
    url: `operation/inspectParkingLot/parkingAdjustmentItems`,
    params: {
      state,
      center,
      radius,
      coordinateSystem,
    },
  });
}

export async function findById(adjustmentId: string): Promise<AxiosResponse<any>> {
  return await v1({
    url: `operation/inspectParkingLot/parkingAdjustmentItems/${adjustmentId}`,
  });
}

export async function audit(adjustmentId: string, remark: string): Promise<AxiosResponse<any>> {
  return await v1({
    url: `operation/inspectParkingLot/parkingAdjustmentItems/${adjustmentId}/audit`,
    method: 'put',
    data: {
      remark,
    },
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/operation/adjustment.ts